import { render, staticRenderFns } from "./ProjectViewPage.vue?vue&type=template&id=41b8b3b8&scoped=true&"
import script from "./ProjectViewPage.vue?vue&type=script&lang=js&"
export * from "./ProjectViewPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41b8b3b8",
  null
  
)

export default component.exports